import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Article.css";
import NavComplete from "../Component/Navbar1";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Alert from "react-bootstrap/Alert";
import Footer from "../Component/footer";
import Card from "react-bootstrap/Card";
import LoadingImage from "../Component/Loadingimage";
import { useRef } from "react";
// {localStorage.getItem("bahasa") === "ing"?``:``}
function Article1() {
  const handleCardClick = (link) => {
    window.location.href = `${link}`;
  };
  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const section4 = useRef(null);
  const section5 = useRef(null);

  const scrollToPromo = (ref) => {
    const navbarHeight = 88; // Replace with the actual height of your navigation bar
    const rect = ref.current.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetOffset = rect.top + scrollTop - navbarHeight;

    window.scrollTo({
      top: targetOffset,
      behavior: "smooth",
    });
  };
  const togglescroll1 = () => {
    scrollToPromo(section1);
  };
  const togglescroll2 = () => {
    scrollToPromo(section2);
  };
  const togglescroll3 = () => {
    scrollToPromo(section3);
  };
  const togglescroll4 = () => {
    scrollToPromo(section4);
  };
  const togglescroll5 = () => {
    scrollToPromo(section5);
  };
  return (
    <article>
      <div id="containerss">
        <NavComplete />
        <Container
          className="info-page"
          style={{
            color: "white",
            marginTop: "80px",
            marginBottom: "80px",
            maxWidth: "900px",
            fontFamily: "nunito",
          }}
        >
          <Breadcrumb>
            <Breadcrumb.Item href="/Informasi">Blog</Breadcrumb.Item>
            <Breadcrumb.Item active>
              {localStorage.getItem("bahasa") === "ing"
                ? ` Avoid 5 Unnoticed Causes of Fine Scratches on Your Car's Surface!`
                : `Hindari 5 Penyebab Munculnya Baret Halus Pada Permukaan Mobil yang
            Jarang Disadari!`}
            </Breadcrumb.Item>
          </Breadcrumb>
          <Row>
            <Col>
              <h1 style={{ fontFamily: "raleway" }}>
                {localStorage.getItem("bahasa") === "ing"
                  ? ` Avoid 5 Unnoticed Causes of Fine Scratches on Your Car's Surface!`
                  : `Hindari 5 Penyebab Munculnya Baret Halus Pada Permukaan Mobil yang
            Jarang Disadari!`}
              </h1>
              <div style={{ marginBottom: "15px", gap: "20px" }}>
                <i style={{ padding: "0px 2px" }} class="bi bi-person"></i>
                <a
                  style={{ padding: "0px 5px", marginRight: "10px" }}
                  target="blank_"
                  href="https://www.instagram.com/rezzaalviansyah/"
                >
                  Rezza
                </a>
                <i
                  style={{ padding: "0px 2px" }}
                  class="bi bi-calendar4-week"
                ></i>
                <span style={{ padding: "0px 5px" }}>25 oktober 2023</span>
              </div>
              <img
                src="https://i.ibb.co.com/8jzmMc1/ezgif-com-gif-maker.webp"
                alt="Micro props"
                className="info-image"
              />
              <Alert
                variant="dark"
                style={{
                  background:
                    "linear-gradient(156deg, rgba(0,0,0,1) 41%, rgba(250,0,8,1) 120%)",
                  color: "white",
                  borderColor: "red",
                }}
              >
                <h3>
                  {localStorage.getItem("bahasa") === "ing"
                    ? "Article Content: Avoid this 5 things"
                    : "Isi Artikel: Hindari lima hal ini"}
                </h3>
                <ul>
                  <li onClick={togglescroll1}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Microfiber cloth"
                      : "Lap microfiber"}
                  </li>
                  <li onClick={togglescroll2}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? "The wrong Chamois"
                      : "Kanebo yang salah"}
                  </li>
                  <li onClick={togglescroll3}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Nail scratches"
                      : "Goresan Kuku"}
                  </li>
                  <li onClick={togglescroll4}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Animal Hoofprints"
                      : "Jejak Kuku Hewan"}
                  </li>
                  <li onClick={togglescroll5}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? "High PH Soap"
                      : "Sabun Dengan PH Tinggi"}
                  </li>
                </ul>
              </Alert>
              <div style={{ textAlign: "start" }}>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? ` Imagine you've been working tirelessly, exerting your energy and mental efforts. With every payday, you set aside a portion of your salary to buy a car. You surely wouldn't want the car you've worked hard for to be scratched and scuffed, right?`
                    : ` Bayangkan kamu sudah kerja banting tulang, cape tenaga, dan cape pikiran. Setiap tanggal gajian kamu menyisihkan sebagian gaji
                kamu untuk membeli mobil. Kamu pasti nggak rela kan kalo mobil
                yang kamu beli dengan susah payah baret dan lecet?`}
                </p>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? `What's annoying is that the fine scratches or swirls still
                    staining the surface of your car's paint, even though you have tried to to take care of it as much as you can.`
                    : ` Nah yang menjengkelkan adalah baret halus atau swirl tetap
                menodai permukaan cat mobil kamu, padahal kamu sudah berusaha
                merawatnya semampu kamu.`}
                </p>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? ` In order to keep your car smooth and avoid fine scratches, you
                need to know the causes of the appearance of fine scratches or swirls on the
                car paint surface. Let's take a look at the five causes of the appearance of fine scratches
                on the surface of car paint below!`
                    : `Agar mobil kamu tetap mulus dan terhindar dari baret halus, kamu
                perlu tahu penyebab munculnya baret halus atau swirl pada
                pemukaan cat mobil. Yuk simak lima penyebab munculnya baret
                halus pada permukaan cat mobil di bawah ini!`}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section1}>
                <b>
                  <h2 style={{ marginBottom: "20px" }}>
                    {" "}
                    {localStorage.getItem("bahasa") === "ing"
                      ? `1.Microfiber Cloth`
                      : `1. Lap
                  Microfiber`}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/NmcGYxb/Whats-App-Image-2023-10-17-at-11-41-11-72b6e2d0.jpg"
                  alt="Micro props"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `The Mirofiber cloth is a kind of fiber-based cleaning cloth with a
                  fineness level below one denier made from
                  microfiber technology.`
                      : `Lap Mirofiber itu sejenis kain pembersih berbahan serat dengan
                  tingkat kehalusan di bawah satu denier yang terbuat dari
                  teknologi microfiber.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `You might ask, aren't there many automotive sites that
                  recommend Microfiber Cloth as a tool to
                  cleaning the car?`
                      : `  Mungkin kamu bertanya, bukankah banyak situs otomotif yang
                  merekomendasikan Lap Microfiber sebagai alat untuk
                  membersihkan mobil?`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Many people don't realize that Microfiber Wipe
                  is one of the causes of the appearance of fine scratches on the
                  on the car's paint surface. Well, the microfiber cloth that you shouldn't use to wipe your
                  should not use to wipe your car is a microfiber cloth whose
                  thickness of the material is below 320 GSM.`
                      : `Banyak orang yang nggak sadar kalo ternyata Lap Microfiber
                  merupakan salah satu dari penyebab munculnya baret halus pada
                  permukaan cat mobil. Nah, Lap Microfiber yang nggak boleh kamu
                  gunakan untuk mengelap mobil kamu adalah Lap Microfiber yang
                  ketebalan bahannya di bawah 320 GSM.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `The surface of car paint is like human skin to keep it smooth,
                  don't choose the wrong skincare. So, don't use
                  the wrong Microfiber Cloth to clean your car!`
                      : `Permukaan cat mobil layaknya kulit manusia agar tetap mulus,
                  jangan sampai salah pilih skincare. Jadi, jangan lagi pakai
                  Lap Microfiber yang salah untuk membersihkan mobil kamu ya!`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section2}>
                <b>
                  <h2 style={{ marginBottom: "20px" }}>
                    2.{" "}
                    {localStorage.getItem("bahasa") === "ing"
                      ? "The wrong Chamois"
                      : "Kanebo yang salah"}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/LJ5xLtS/lap-kanebo.webp"
                  alt="Micro props"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Chamois Wipe is a versatile product that is often used not only for wiping vehicles, but also in everyday life.`
                      : `Lap Kanebo atau Lap Chamois menjadi salah satu produk serbaguna yang kerap digunakan bukan hanya untuk mengelap kendaraan, tapi juga sering digunakan untuk kehidupan sehari-hari.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `There are many brands of chamois circulating and used in Indonesia such as 3M, Kenmaster, Tutrle Wax, or Proclean, but Indonesians still call it Chamois Wipe.`
                      : `Ada banyak merek kanebo yang beredar dan digunakan di Indonesia seperti 3M, Kenmaster, Tutrle Wax, atau pun Proclean, namun masyarakat Indonesia tetap menyebutnya Lap Kanebo.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Its high absorbency makes chamois a favorite for many people. But it turns out that chamois can also be the cause of fine scratches on the surface of car paint.`
                      : `Daya serap yang tinggi membuat kanebo menjadi primadona bagi banyak orang. Tapi ternyata kanebo juga bisa menjadi penyebab muncul baret halus pada permukaan cat mobil loh.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `So, before using a chamois cloth as a tool to clean and maintain your car, you must be careful and not choose the wrong chamois!`
                      : `Jadi, sebelum menggunakan lap kanebo sebagai alat untuk membersihkan dan merawat mobil, kamu harus teliti dan nggak boleh salah pilih kanebo!`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section3}>
                <b>
                  <h2 style={{ marginBottom: "20px" }}>
                    3.
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Nail scratches"
                      : "Goresan Kuku"}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/wgWDRxK/ezgif-com-resize.webp"
                  alt="Micro props"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `The cause of fine scratches on the surface of car paint that car owners rarely realize is nail scratches.`
                      : `Penyebab munculnya baret halus pada permukaan cat mobil yang jarang disadari oleh pemilik mobil adalah goresan kuku.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Don't just focus on taking care of your car, until you forget to take care of yourself. Because you will experience two losses at once, the first is that you might get hurt, the second is that your nails can cause fine scratches on your favorite car.`
                      : `Jangan hanya karena fokus ngurusin dan merawat mobil, sampe kamu lupa merawat diri kamu sendiri. Karena kamu akan mengalami dua kerugian sekaligus, yang pertama mungkin saja kamu bisa luka, yang kedua kuku bisa menimbulkan baret halus pada mobil kesayangan kamu.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Imagine wanting to wipe your car to make it shiny, but instead, you end up causing fine scratches on the car's paint surface. So, to keep your car shiny, make sure to trim your nails before wiping your car!`
                      : `Bayangkan, niat hati ingin mengelap mobil agar kinclong, tapi justru malah menimbulkan baret halus pada permukaan cat mobil. Jadi, agar mobil kamu tetap kinclong, pastikan potong dulu kuku kamu sebelum mengelap mobil!`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section4}>
                <b>
                  <h2 style={{ marginBottom: "20px" }}>
                    4.
                    {localStorage.getItem("bahasa") === "ing"
                      ? "Animal Hoofprints"
                      : "Jejak Kuku Hewan"}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/Ry2nJMb/ezgif-com-resize.webp"
                  alt="Micro props"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `For those of you who have pets at home, hoof prints are a serious threat to your car. Especially if your pet is not in a cage at home.`
                      : `Bagi kamu yang punya hewan peliharaan di rumah, jejak kuku hewan menjadi ancaman serius bagi mobil kamu. Apalagi kalo hewan peliharaan kamu di rumah tidak di kandang. `}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Whether it's a cat, dog, or chicken, there's no way you can spend all day observing your pet's behavior.`
                      : `Entah itu kucing, anjing, atau pun ayam, yang pasti kamu nggak mungkin meluangkan waktu seharian untuk mengamati perilaku hewan peliharaan kamu.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `So, it would be useless if you wash your car for hours with an expensive brand of car shampoo, wipe it with a branded chamois and coat it again with a shampoo kit, only to find that there are still fine scratches on the surface of your car paint.`
                      : `Jadi, akan sangat percuma kalo kamu nyuci mobil berjam-jam lamanya dengan merek shampo mobil yang mahal, setelah itu dilap dengan kanebo bermerk dan agar lebih kinclong dibalut lagi dengan kit shampoo, tapi ternyata masih muncul baret halus pada permukaan cat mobil kamu.`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row style={{ marginBottom: "50px" }}>
            <Col>
              <section ref={section5}>
                <b>
                  <h2 style={{ marginBottom: "20px" }}>
                    5.
                    {localStorage.getItem("bahasa") === "ing"
                      ? "High PH Soap"
                      : "Sabun Dengan PH Tinggi"}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/5KVxzgJ/Soap.webp"
                  alt="Micro props"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `It feels incomplete to wash anything without using soap. Soap is a mandatory item used by everyone to wash. But many people don't understand that there is PH content in soap.`
                      : `Rasanya tidak lengkap kalo mencuci apapun tanpa menggunakan sabun. Sabun menjadi barang wajib yang digunakan oleh setiap orang untuk mencuci. Tapi banyak orang yang nggak mengerti bahwa ada kandungan PH di dalam sabun.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Well, soap with a high PH content can be the cause of fine scratches on the surface of your car paint. A PH value below 7 means the acidity is high, while 8-14 means the alkaline content is high.`
                      : `Nah, sabun dengan kandungan PH yang tinggi ini bisa menjadi penyebab munculnya baret halus pada permukaan cat mobil milikmu. Kandungan nilai PH di bawah 7 berarti kadar keasamannya tinggi, sementara 8-14 kandungan alkalinya banyak. `}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Just like human skin, the more the paint is exposed to soap suds, the faster it becomes dull and dry. This makes it easy for the car paint to develop scratches because it is tight when wiped. So the best soap for washing cars is soap with a PH level close to 7 (PH balance).`
                      : `Sama seperti kulit manusia, semakin banyak cat terkena busa sabun semakin cepat kusam dan kering. Keadaan ini gampang membuat cat mobil timbul baret karena kesat saat di lap. Jadi sabun paling bagus untuk mencuci mobil adalah sabun memiliki tingkat PH mendekati 7 (PH balance).`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Now, you know the five causes of fine scratches on your car's paint surface. So, there's no reason to let fine scratches stain the paint surface of your car!`
                      : `Nah, sekarang kamu sudah tahu kan lima penyebab munculnya baret halus pada permukaan cat mobil. Jadi, sudah nggak ada alasan lagi untuk membiarkan baret halus menodai permukaan cat mobil milikmu!.`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Card
            className="bg-dark "
            style={{
              position: "relative",
              overflow: "hidden",
              alignSelf: "center",
            }}
            onClick={() => handleCardClick("/layanan-harga")}
          >
            <LoadingImage
              src="https://i.ibb.co.com/cgMDvsz/Coating-image.jpg"
              alt="Card image"
              className="card-overlay"
            />
            <Card.ImgOverlay
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "start",
                flexDirection: "column",
                color: "red",
              }}
            >
              <Card.Title>
                <b>Detailing</b>
              </Card.Title>
              <Card.Text
                style={{ backdropFilter: "blur(2px)", fontFamily: "raleway" }}
              >
                {localStorage.getItem("bahasa") === "ing"
                  ? ` Protect your car from fine scratches with detailing at Wecarcare.`
                  : `Lindungi mobil anda dari Baret Halus dengan Detailing di Wecarcare`}
              </Card.Text>
            </Card.ImgOverlay>
          </Card>
        </Container>
        <Footer />
      </div>
    </article>
  );
}

export default Article1;
